import ValidationInterface from '@/plans/common/validation-interface';
import { basePlanWithoutZrCategories, basicPlusCategories } from '@/common/persist-cart/categories';

export default class extends ValidationInterface {
  async requires() {
    return [
      this.current('CUSTOMAVATARS').require([...basePlanWithoutZrCategories, 'zoom_clips', ...basicPlusCategories]),
    ];
  }

  async conflicts() {
    return this.current(['CUSTOMAVATARS']).conflict(['CUSTOMAVATARS']);
  }
}
